window.__assetPrefix__ = 'https://d1jyzj0nb1dysn.cloudfront.net/vercel-frontend-notifications-center';